﻿import { useQuery, useMutation, useQueryClient } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";

import { getVersion, getVersions, saveVersion, deleteVersion } from "@/api/Maintainers/versions";

const key = "versions";

export function useVersion(selected) {
	return useQuery([key, selected], () => selected && getVersion({ selected }));
}

export function useVersionsPaginate(params) {
	return useQuery([key, params], () => getVersions(params));
}

export function useMutateVersion(params) {
	const navigate = useNavigate();
	const location = useLocation();
	const queryClient = useQueryClient();

	return useMutation(saveVersion, {
		onSuccess: (response) => {
			const versions = _.omit(response, "detail");
			const version = _.omit(response, key);

			queryClient.setQueryData([key, String(version.detail.id)], version);
			queryClient.setQueryData([key, params], versions);

			if (params.search) {
				queryClient.invalidateQueries([key]);
			}

			if (location.state) {
				navigate(location.state);
				return;
			}

			navigate("/mantenedores/versiones");
		},
	});
}

export function useMutateDeleteVersion(params) {
	const queryClient = useQueryClient();

	return useMutation(deleteVersion, {
		onSuccess: (response) => {
			queryClient.setQueryData([key, params], response);
		},
	});
}
